import { Component, inject, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Menu } from '../shared/model/security/menu.model';
import { rutaDeMenu, seVeEnElPanel, tieneQuePintar, unirFactories } from '../shared/menu/ruta-menu';
import { AuthService } from '../security/auth.service';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { ComunicacionService } from '../shared/services/comunicacion.service';
import { DatePipe, CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
declare const $: any;

@Component({
    selector: 'app-sidebar-cmp',
    standalone: true,
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.css'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,RouterLinkActive, RouterLink, DatePipe],
    providers: [
        DatePipe
    ] 
})

export class SidebarComponent implements OnInit {
    public menuItems: Menu[];
    fecha: Date = new Date();
    
    menuMovilView:boolean;
    ps: any;
    expandedMenus = new Set<string>();

    private readonly comunicacion = inject(ComunicacionService);
    private readonly router = inject(Router);
    private readonly authS = inject(AuthService);
    constructor() { }

    
    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {
        // Primero lo guardado, para que el menu aparezca de inmediato.
        this.menuItems = this.authS.getMenuList();
        // Y cada vez que alguien lo vuelva a leer (la Consola, al guardar
        // el menu nuevo, lo refresca): se repinta sin F5.
        this.authS.menuCambiado.subscribe((menus) => {
            this.menuItems = menus;
        });
        // Y en seguida lo que diga el servidor. El menu se escribia SOLO
        // al iniciar sesion, asi que un permiso nuevo —o uno retirado— no
        // se veia hasta cerrar sesion y volver a entrar; con esto basta un
        // F5. Es una peticion de fondo: ni velo de carga, ni cierre de
        // sesion si contesta 401, ni reinicio del reloj de inactividad.
        this.authS.refrescarMenus().subscribe({
            next: (menus) => {
                // `menus.length`, no `menus` a secas: un arreglo vacio es
                // TRUTHY en JavaScript, y el servidor contesta 200 con la
                // lista VACIA cuando la sesion HTTP ya caduco
                // (MenuService.consultaMenusXUserAngular: si
                // idUsuarioSession es nulo escribe "idUsuarioSession: null"
                // y devuelve la lista sin llenar; en CosRest no hay 401
                // porque FilterSeguridad esta comentado entero).
                //
                // Sin esta guarda, quien dejara la pestania abierta media
                // hora y pulsara F5 se quedaba SIN MENU en las cincuenta
                // pantallas del COS, no solo en esta. Una lista vacia del
                // servidor hoy no quiere decir "te quitaron todo": quiere
                // decir "no se quien eres".
                if (menus?.length) {
                    this.menuItems = menus;
                    // El scroll se recalcula solo si existe: si la ventana
                    // era estrecha al arrancar, no se creo.
                    setTimeout(() => {
                        if (this.ps) {
                            this.updatePS();
                        }
                    }, 0);
                }
            },
            // Si falla se queda el de siempre: un menu viejo es mejor que
            // ninguno, y esto no lo pidio nadie a proposito.
            error: () => {},
        });
        this.comunicacion.customMenuMovilView.subscribe(menuMovil=>this.menuMovilView=menuMovil);
   
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }
    }


    updatePS(): void  {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }

    isMac(): boolean {
        let bool = false;
        
        if (navigator.userAgent.includes('Mac') || navigator.userAgent.includes('IPAD')  ) {
            bool = true;
        }
        return bool;
    }
    expandOrCollapseMenu(id: string, event?: Event){
        event?.preventDefault();
        if (!id) {
            return;
        }
        if (this.expandedMenus.has(id)) {
            this.expandedMenus.delete(id);
        } else {
            this.expandedMenus.add(id);
        }
        setTimeout(() => this.updatePS(), 0);
    }

    isMenuExpanded(id: string): boolean {
        return this.expandedMenus.has(id);
    }
    
    ocultarMenu(): void {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('nav-open');
        Array.from(document.getElementsByClassName('close-layer')).forEach((layer) => layer.remove());
        Array.from(document.getElementsByClassName('navbar-toggler')).forEach((toggle) => toggle.classList.remove('toggled'));
        this.comunicacion.changeMenuMovilView(false);
    }

    /** A donde lleva una entrada: su ruta completa si la trae, si no padre + hoja. */
    linkDe(item: Menu, padre?: Menu): string[] {
        return rutaDeMenu(item, padre);
    }

    /** Configuracion y Consola se pintan abajo, separadas de los grupos. */
    esFijo(item: Menu): boolean {
        return (item?.seccion || "").toLowerCase() === "fijo";
    }

    get fijos(): Menu[] {
        return (this.menuItems || []).filter((item) => this.esFijo(item) && tieneQuePintar(item));
    }

    /** Los grupos de arriba: sin los fijos ni los que no tienen nada que pintar. */
    deArriba(item: Menu): boolean {
        return !this.esFijo(item) && tieneQuePintar(item);
    }

    getMenuRouterLink(...factories: Array<string | undefined | null>): string[] {
        return unirFactories(...factories);
    }

    /** Las hojas que se pintan: sin las que se abren desde otro modulo. */
    hijosEnPanel(item: Menu): Menu[] {
        return (item?.hijos || []).filter(seVeEnElPanel);
    }

    /**
     * Pantallas sin hoja propia en el panel que se abren desde una hoja:
     * mientras se esta en ellas, esa hoja queda marcada (29/09/2026: la
     * Matriz de Riesgos IA, las matrices de cada area y «Cambios por
     * aprobar» se abren desde Gestion de Riesgos; 07/10/2026: el detalle de
     * un proyecto de Calidad de codigo se abre desde su Tablero). Las rutas
     * son constantes a proposito: el *ngFor las compara por referencia en
     * cada ciclo. La llave es el factory de la hoja en minusculas y sin las
     * diagonales de los extremos (ver abreTambien).
     */
    private static readonly SE_ABREN_DESDE: Record<string, string[][]> = {
        gestionriesgos: [
            ['/RIESGOS/matriz'],
            ['/RIESGOS/matrizRiesgosIA'],
            ['/RIESGOS/cambiosPorAprobar'],
        ],
        'admin/calidad-codigo/tablero': [
            ['/admin/calidad-codigo/proyecto'],
        ],
    };
    private static readonly NINGUNA: string[][] = [];

    abreTambien(item: Menu): string[][] {
        // Sin las diagonales de los extremos; la cola arranca tras un caracter que no es diagonal ($1 lo devuelve).
        const factory = (item?.factory || '').trim().replace(/^\/+|([^/])\/+$/g, '$1').toLowerCase();
        return SidebarComponent.SE_ABREN_DESDE[factory] || SidebarComponent.NINGUNA;
    }

}
